<template>
  <Layout2
    title="Verify your mobile"
    padTop="200px"
  >

    <template slot="form">
      <form @submit.prevent="">
        <div>
            <label class="col_secondary fn14">Enter the verification code received on <strong>({{this.data.MobileData.countryCode}}){{this.data.MobileData.mobileNumber}}</strong></label>
        </div>
        <div v-if="isMobileRequired && emailVerified">
                <p class="pt10 fn14 ln_ht20 fw400">
                  A one time password has been sent to your mobile number. Enter the password to verify.
                </p>
                <div class="form-floating mb15">
                  <input
                    v-model="OTP"
                    label="OTP"
                    v-validate="{required: true, integer: true}"
                    data-vv-name="otp"
                    placeholder="OTP"
                    data-vv-validate-on="input|blur|update|change"
                    id="otp"
                    name="otp"
                    class="form-control fn14"
                  />
                  <label for="emailOtp">OTP</label>
                  <small class="col_error" v-show="errors.has('otp')">{{ errors.first('otp') }}</small>
                </div>
                <span v-if='counterMessage' class='pb-0 fn14 ln_ht20 fw400'>You can request another OTP in <strong>{{countDown}}</strong> sec</span>
                <p v-if='showResendBtn' class="text-primary-apiculus link disFlex align-center fn14 ln_ht20 fw400" @click='resendOTP()'><v-icon class="text-primary-apiculus">replay</v-icon> Resend OTP</p>
              </div>
              <div class="form-floating mt10">
                <input
                    type="text"
                    id="otp"
                    placeholder="OTP"
                    class="form-control fn14"
                    name="OTP"
                    v-model="OTP"
                    label="OTP"
                    v-validate="{required: true, integer: true}"
                />
                <label for="OTP">OTP</label>
                <small class="col_error" v-show="errors.has('OTP')">{{ errors.first('OTP') }}</small>
              </div>
          
          <div class="mb20 mt20 disFlex">
          <input type="submit" class="btn btn-apiculus-primary" value="CONTINUE" :disabled="validate"  @click="verifyOTP()" />
          <div class="pl-3 mt-3">
                <span v-if='counterMessage' class='pb-0'>You can request another OTP in <strong>{{countDown}}</strong> sec</span>
                <p v-if='showResendBtn' class="text-primary-apiculus link disFlex align-center" @click='resendOTP()'><v-icon class="text-primary-apiculus">replay</v-icon> Resend OTP</p>
              </div>
          <!-- <v-btn color="primary" :disabled="!verificationCodeValid" v-if="!(isMobileRequired && emailVerified)" @click="initiateEmailVerification()">Verify Email</v-btn> -->
        </div>
      </form>
    </template>
  </Layout2>
</template>

<script>
import Layout2 from './Layout2.vue'
// import VueRecaptcha from 'vue-recaptcha'
import { mapGetters } from 'vuex'
import helpers from '../../services/toast-service'

export default {
  name: 'mobileVerificationOTP',
  mixins: [helpers],
  data () {
    return {
        form: {},
        data: {},
        color: '',
        message: '',
        OTP: '',
        showResendBtn: true,
        counterMessage: false,
        countDown: '',
        remainingAttempts: '',
    }
  },
  components: {
    Layout2
      },
  computed: {
     ...mapGetters({
         getCountryNameWithCode: 'getCountryNameWithCode',
    }),
    counterTime () {
      return this.$store.state.ApiculusEnv.OTPTimer || 20
    },
  },
  mounted () {
    let userDetails = this.$route.params
    if (!(Object.keys(userDetails).length > 0)) {
      this.$router.push('/signup')
    } else {
      this.data = userDetails
      this.form = {
          email : userDetails.email,
          mobileNumber : userDetails.MobileData.mobileNumber,
          countryCode : userDetails.MobileData.countryCode,
          regSessionToken : userDetails.regSessionToken,
          verified : true
          }
    }
    this.countDown = this.counterTime
  },
  methods: {
      otpTimer () {
      let interval = setInterval(() => {
        this.countDown--
        if (this.countDown <= 0) {
          this.counterMessage = false
          this.showResendBtn = true
          clearInterval(interval)
        }
      }, 1000)
    },
    verifyOTP () {
        this.$validator.validateAll().then((result) => {
            if (result) {
                this.form.otp = this.OTP
      this.$store.dispatch('ACTION_VERIFY_OTP', this.form).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'OTP expired.', 'error')
        } else if (res.success && res.result.verified) {
          this.toastAlert('OTP verified successfully', 'success')
          let obj = { ...res.result, mobileVerified: true, emailVerified: this.emailVerified }
          this.$router.push({ name: 'SetNewPassword', params: obj })
        }
      })
            }
            else {
            this.toastAlert('Please input OTP', 'error')
            }
        })
    },
    resendOTP () {
      this.$store.dispatch('ACTION_RESEND_SIGNUP_OTP', { ...this.form }).then(res => {
        if (!res.success) {
          this.toastAlert(res.error.message || 'Something went wrong.', 'error')
        } else {
          this.toastAlert('OTP sent successfully.', 'success')
        }
      })
      this.counterMessage = true
      this.countDown = this.counterTime
      this.showResendBtn = false
      this.otpTimer()
    }
},
created () {
    this.$store.dispatch('ACTION_GET_COUNTRY_NAME')
}
}
</script>

<style scoped>
.c_select>.v-input__control>.v-input__slot:before { 
  border-style: none; 
} 
.c_select>.v-input__control>.v-input__slot:after { 
  border-style: none; 
}

</style>
